<template>
  <HeaderPanel class="user-list-root" title="固定收费报表" subTitle>
    <Panel>
      <div style="padding:10px 20px 20px 20px">
        <a-tabs :activeKey="activeKey" @change="activeKey = arguments[0]">
          <a-tab-pane tab="机构视图" :key="0">
            <org
              exportResourseKey="system:fixed-report:export"
              :vm="_self"
              ref="org"
              businessType="fixed"
              tableRef="fixedOrg"
            />
          </a-tab-pane>
          <a-tab-pane tab="车场视图" :key="1">
            <org
              exportResourseKey="system:fixed-report:export"
              :vm="_self"
              ref="park"
              businessType="fixed"
              tableRef="fixedPark"
            />
          </a-tab-pane>
        </a-tabs>
      </div>
    </Panel>
  </HeaderPanel>
</template>
<script>
import org from './components/org/entry.vue';
export default {
  name: 'FixedReport',
  mixins: [],
  components: {
    org
    // park,
  },
  mounted() {
    if (process.env.NODE_ENV != 'production') {
      window._org = window._self.$refs.org;
      window._park = window._self.$refs.park;
    }
  },
  data() {
    return {
      activeKey: 0
    };
  }
};
</script>
